import React, { useCallback } from 'react';
import { faDownload, faPencil, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { DocumentAttachment } from '@spike/client-model';
import ThreeDotsDropdown from 'components/UI/V3/ThreeDotsDropdown/ThreeDotsDropdown';
import { ThreeDotsDropdownOption } from 'components/UI/V3/ThreeDotsDropdown/ThreeDotsDropdownOption';
import styles from './DocumentOption.module.scss';

export interface DocumentOptionProps {
    document: DocumentAttachment;
    onDownload: (doc: DocumentAttachment) => void;
    onRename: (doc: DocumentAttachment) => void;
    onDelete: (doc: DocumentAttachment) => void;
}

export const DocumentOption: React.FC<DocumentOptionProps> = ({ document, onDownload, onRename, onDelete }) => {
    const threeDotsOptions = useCallback(
        (): ThreeDotsDropdownOption[] => [
            {
                id: 'rename',
                label: 'Edit',
                icon: faPencil,
                onClick: () => onRename(document)
            },
            {
                id: 'download',
                label: 'Download',
                icon: faDownload,
                onClick: () => onDownload(document)
            },
            {
                id: 'delete',
                label: 'Delete',
                icon: faTrashCan,
                onClick: () => onDelete(document)
            }
        ],
        [document, onDownload, onRename, onDelete]
    );

    return (
        <div className={styles.root}>
            <ThreeDotsDropdown
                options={threeDotsOptions()}
                direction="down"
            />
        </div>
    );
};

export default DocumentOption;
